import { createContext, ReactNode, useContext, useRef } from "react"
import { Provider } from "jotai"
import { createCellStore } from "./cellStore"
import { BaseRecord } from "./types"

type CellStoreContextType = ReturnType<typeof createCellStore>
const CellStoreContext = createContext<CellStoreContextType | undefined>(
  undefined,
)

export function useCellStore() {
  const c = useContext(CellStoreContext)
  if (c === undefined) {
    throw new Error("useCellStore context undefined")
  }
  return c
}

function CellStore<R extends BaseRecord>(props: { children: ReactNode }) {
  const storeRef = useRef<CellStoreContextType | undefined>(undefined)

  if (!storeRef.current) {
    storeRef.current = createCellStore<R>()
  }

  return (
    <CellStoreContext.Provider value={storeRef.current}>
      {props.children}
    </CellStoreContext.Provider>
  )
}

export function TableScope<R extends BaseRecord>(props: {
  children: ReactNode
}) {
  return (
    <Provider>
      <CellStore<R>>{props.children}</CellStore>
    </Provider>
  )
}
